module.exports = __webpack_public_path__ + "static/media/hotel-2.c4c25521.jpg";